import { render, staticRenderFns } from "./AddEntityReationshipDataWidget.vue?vue&type=template&id=484ce920&scoped=true"
import script from "./AddEntityReationshipDataWidget.vue?vue&type=script&lang=js"
export * from "./AddEntityReationshipDataWidget.vue?vue&type=script&lang=js"
import style0 from "./AddEntityReationshipDataWidget.vue?vue&type=style&index=0&id=484ce920&prod&lang=scss&scoped=true"
import style1 from "./AddEntityReationshipDataWidget.vue?vue&type=style&index=1&id=484ce920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ce920",
  null
  
)

export default component.exports